import { useQuery } from "@tanstack/react-query";
import { getConfigObject, useBaseContent } from "../../utils/utils";
import {
  GetPatientAllPaymentPaymentModeEnum,
  GetPatientAllPaymentTypeOfPaymentEnum,
  PatientPaymentControllerApi,
} from "../../services";

interface Params {
  patientUuid?: string;
  xTENANTID?: string;
  transactionDate?: string;
  transactionId?: string;
  paymentMode?: GetPatientAllPaymentPaymentModeEnum;
  /**
   * Restricts the result to a single payment source. Pass `PATIENT` to exclude
   * insurance (ERA) payments from the list.
   */
  typeOfPayment?: GetPatientAllPaymentTypeOfPaymentEnum;
}

/**
 * @author Rajkumar Rathod
 */
export const useStripeGetAllCard = (params: Params): useBaseContent<any> =>
  useQuery({
    queryKey: ["stripe-payment-cards", params],
    retry: (failCount) => failCount < 0,
    queryFn: () =>
      new PatientPaymentControllerApi(getConfigObject())
        .getPatientAllPayment(
          0, //page
          100, //size
          undefined, //sortBy
          params?.paymentMode, //paymentMode
          params?.typeOfPayment, //typeOfPayment
          undefined, //sort
          params?.transactionId, //transactionId
          params?.transactionDate, //transactionDate
          params?.patientUuid, //patientUuid
          undefined, //searchString
          params?.xTENANTID //xTENANTID
        )
        .then((res) => res?.data),
  });
